module.exports = __webpack_public_path__ + "img/logo_colored.1030ae6a.png";